var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroRegisterPic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 15.5C1.25 15.5 0 15.5 0 14.25C0 13 1.25 9.25 7.5 9.25C13.75 9.25 15 13 15 14.25C15 15.5 13.75 15.5 13.75 15.5H1.25ZM7.5 8C8.49456 8 9.44839 7.60491 10.1517 6.90165C10.8549 6.19839 11.25 5.24456 11.25 4.25C11.25 3.25544 10.8549 2.30161 10.1517 1.59835C9.44839 0.895088 8.49456 0.5 7.5 0.5C6.50544 0.5 5.55161 0.895088 4.84835 1.59835C4.14509 2.30161 3.75 3.25544 3.75 4.25C3.75 5.24456 4.14509 6.19839 4.84835 6.90165C5.55161 7.60491 6.50544 8 7.5 8Z",
    fill: "#32B77A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.875 4.25C17.0408 4.25 17.1997 4.31585 17.3169 4.43306C17.4342 4.55027 17.5 4.70924 17.5 4.875V6.75H19.375C19.5408 6.75 19.6997 6.81585 19.8169 6.93306C19.9342 7.05027 20 7.20924 20 7.375C20 7.54076 19.9342 7.69973 19.8169 7.81694C19.6997 7.93415 19.5408 8 19.375 8H17.5V9.875C17.5 10.0408 17.4342 10.1997 17.3169 10.3169C17.1997 10.4342 17.0408 10.5 16.875 10.5C16.7092 10.5 16.5503 10.4342 16.4331 10.3169C16.3158 10.1997 16.25 10.0408 16.25 9.875V8H14.375C14.2092 8 14.0503 7.93415 13.9331 7.81694C13.8158 7.69973 13.75 7.54076 13.75 7.375C13.75 7.20924 13.8158 7.05027 13.9331 6.93306C14.0503 6.81585 14.2092 6.75 14.375 6.75H16.25V4.875C16.25 4.70924 16.3158 4.55027 16.4331 4.43306C16.5503 4.31585 16.7092 4.25 16.875 4.25Z",
    fill: "#32B77A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroRegisterPic);
export default __webpack_public_path__ + "static/media/introRegisterPic.49e2144ec1b3b87dd9100bd7ec7010d5.svg";
export { ForwardRef as ReactComponent };